import React from 'react';
import { Table } from 'reactstrap';
import { IAdvanceRequestType } from '../../../types/AdvanceRequestTypes';
import { IEmployeeType } from '../../../types/EmployeeTypes';
import { getProductDisplayName, getTypeDisplayName, getAdvanceAccountLabelAndValue } from '../../../types/AdvanceTypeMapping';

interface EmployeeModalTableProps { 
  employee: IEmployeeType;
  advance: IAdvanceRequestType;
}

const EmployeeModalTable: React.FC<EmployeeModalTableProps> = (props) => 
(
    <div className="modal-table-container">
      <Table borderless>
        <thead>
          <tr>
            <th scope="col">Employee Name</th>
            <th scope="col">Type</th>
            <th scope="col">Amount</th>
            <th scope="col">Product</th>
            <th scope="col">{getAdvanceAccountLabelAndValue(props.advance, props.employee).label}</th>
          </tr>
        </thead>
        <tbody>
          {props.employee && props.advance && (
            <tr key={props.employee.id}>
              <td>
                {props.employee.first_name} {props.employee.last_name}
              </td>
              <td style={{ textTransform: 'capitalize' }}>
                {getTypeDisplayName(props.advance.advance_type)}
              </td>
              <td>R {props.advance.amount_requested}</td>
              <td style={{ textTransform: 'capitalize' }}>
                {getProductDisplayName(props.advance.advance_type, props.advance.metadata, props.advance.instant_payment)}
                {props.advance.advance_type === 'VAS' && 
                 props.advance.metadata?.data?.transaction_type === 'data' && 
                 props.advance.metadata?.data?.data_package_selected && (
                  <div style={{ fontSize: '0.85rem', color: '#666' }}>
                    {props.advance.metadata.data.data_package_selected}
                  </div>
                )}
              </td>
            <td>
              {getAdvanceAccountLabelAndValue(props.advance, props.employee).value}
            </td>
            </tr>
          )}
        </tbody>
      </Table>
    </div>
  );
export default EmployeeModalTable;
